import { Pipe, PipeTransform } from '@angular/core';
import { IDocumentDetailRootDTO } from '../../documents/dto/document-details.dto';
import { SigningStatusEnum } from 'app/main/signing-pages/enums/enum';

@Pipe({
  name: 'isDocumentEditable'
})
export class isDocumentEditablePipe implements PipeTransform {

  transform(template: IDocumentDetailRootDTO): boolean {
     return template?.template?.can_edit === true && template?.template?.status !== SigningStatusEnum.SIGNED;
   }

}
